import React from 'react'
import { Trans } from 'react-i18next'
import { connect } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Format } from 'services/Dates'
import { getUserName } from 'services/Utilities'
import { List } from 'ui'
import { t } from 'translations'

const ContactListHistoryModal = ({ contactList, timeZone }) => {
  return (
    <BaseModal title={`manager.contactLists.CONTACT_LIST_HISTORY_MODAL`}>
      <List>
        {(contactList.history || []).map(({ by, action, createdAt }, index) => (
          <List.Item key={index}>
            {/* Show who and when */}
            <Trans t={t} i18nKey={`manager.contactLists.LIST_HISTORY.${action}`}>
              <b>{{ name: getUserName(by) }}</b>
              <b>{{ time: Format(createdAt, { outFormat: 'time', isUTC: true, timeZone }) }}</b>
              {{ date: Format(createdAt, { outFormat: 'humanDate', isUTC: true, timeZone }) }}
            </Trans>
          </List.Item>
        ))}
      </List>
    </BaseModal>
  )
}

const mapStateToProps = ({ contactLists, settings }) => ({ contactList: contactLists.currentContactList, timeZone: settings.defaultTimeZone })

export default connect(mapStateToProps)(ContactListHistoryModal)
